import { motion } from "framer-motion";

export const Waveform = ({ bars = 40, color = "#0a0a0a", active = true, height = 80 }) => {
  return (
    <div
      className="flex items-center justify-center gap-[3px]"
      style={{ height }}
      data-testid="ai-waveform"
    >
      {Array.from({ length: bars }).map((_, i) => (
        <motion.span
          key={i}
          className="w-[3px] rounded-full origin-center"
          style={{ backgroundColor: color, height }}
          initial={{ scaleY: 0.15 }}
          animate={
            active
              ? { scaleY: [0.15, (i % 5) * 0.16 + 0.3, 0.2, (i % 4) * 0.18 + 0.35, 0.15] }
              : { scaleY: 0.12 }
          }
          transition={{
            duration: 1.1 + (i % 5) * 0.12,
            repeat: Infinity,
            ease: "easeInOut",
            delay: (i % 7) * 0.06,
          }}
        />
      ))}
    </div>
  );
};
